import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAllvue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 68,
	height: 28,
	viewBox: "0 0 68 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1265_6575)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.250488 28.1256H4.39069L16.7314 8.91675H12.3232L0.250488 28.1256Z",
				fill: "#8079FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.1145 28.1256H42.1862L42.1503 28.0637L59.4715 0.000488281H55.3313L40.0803 24.4787L30.2023 8.91669H25.6494L37.9265 28.2621H42.0357L42.1145 28.1256Z",
				fill: "#8079FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M67.7167 0H63.5776L46.4956 28.2616H50.7982L67.7167 0Z",
				fill: "#8079FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.2182 9.04443L8.49561 28.1257H12.6358L21.2152 16.2184L28.8606 28.2622H33.4134L21.2182 9.04443Z",
				fill: "#8079FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1265_6575",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 68,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgAllvue;
